import React from 'react'
import PropTypes from 'prop-types'

const t = (key) => (!window.I18n ? key : window.I18n.t(key))

const SearchInput = ({ value, onChange, onClear, placeholder, autoFocus }) => (
  <div className='filter btsp_filter'>
    <div className='input-group'>
      <input
        type='text'
        className='form-control'
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
      />
      <span className='input-group-addon'>
        <button type='button' className='roster-search-clear' onClick={onClear} aria-label={t('customer_groups.groups.members.actions.clear_search')}>
          <i className='fa fa-eraser' aria-hidden='true' />
        </button>
      </span>
    </div>
  </div>
)

SearchInput.propTypes = {
  value:       PropTypes.string.isRequired,
  onChange:    PropTypes.func.isRequired,
  onClear:     PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  autoFocus:   PropTypes.bool,
}

SearchInput.defaultProps = { autoFocus: false }

export default SearchInput
